const logo = () => {
  return {
    to: "/kaz",
    image: {
      header: "1KtVG8Xn7Oi-FoCxa0ZdOG.svg",
      footer: "Z8YgwSSb1FZx2doc3tIH1.svg"
    }
  };
};

const langs = () => {
  return [{ locale: "ru" }, { locale: "kk" }, { locale: "en" }];
};

const meta = banner => {
  return {
    logo: logo(),
    description: {
      to: "/kaz",
      banner
    },
    API: process.env.VUE_APP_KZ,
    langs: langs(),
    mask: "+# (###) ### - ## - ##"
  };
};

export default {
  path: "/kaz",
  children: [
    {
      path: "/kaz/post=:post",
      name: "helpcenter.project",
      meta: meta("PostBanner")
    }
  ],
  name: "helpcenter.project",
  meta: meta("ProjectBanner"),
  component: () => import("@/views/Project.vue")
};
